import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "../../components/Notification";
import {
  assignAppraisalTemplate,
  createAppraisal,
  deleteAppraisal,
  deleteUserAssignedAppraisalById,
  getAllAppraisal,
  getAllUserAssignedAppraisal,
  getEmpAssignedAppraisal,
  getEmployeeAppraisalList,
  submitFinalAppraisal,
  getStatusCountManagerAssignedAppraisal,
  updateUserAdminAppraisal,
  getAdminDashboardData,
  getUserAssignedAppraisalDetails,
  getManagerAssignedAppraisalById,
  getStatusCountUserAssignedAppraisal,
} from "../../api/appraisalApi";

const initialState = {
  appraisals: [],
  employeeAppraisals: [],
  userAssignedAppraisal: [],
  loading: false,
  error: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  message: "",
  empAssignedAppraisalList: [],
  managerAssignedAppraisalList: [],
  selectedAppraisal: null,
  mgrStatusCounts: null,
  adminDataCounts: null,
  userDataCount: {},
};

const appraisalSlice = createSlice({
  name: "appraisalState",
  initialState,
  reducers: {
    deleteAppraisal(state, action) {
      state.appraisals = state.appraisals.filter(
        (appraisal) => appraisal.id !== action.payload
      );
    },
    updateAppraisal(state, action) {
      state.appraisals = state.appraisals.map((appraisal) =>
        appraisal.id === action.payload.id ? action.payload : appraisal
      );
    },
    updateMessage(state, action) {
      state.message = "";
      state.error = null;
      state.status = "loading";
    },
    updateSelectedAppraisal(state, action) {
      state.selectedAppraisal = action.payload;
    },
    resetSelectedAppraisalStates(state) {
      state.selectedAppraisal = null;
      state.loading = false;
      state.error = null;
      state.message = "";
    },
    clearAppraisalCache(state) {
      state.selectedAppraisal = null;
      state.employeeAppraisals = [];
      state.empAssignedAppraisalList = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAppraisal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.appraisals = action.payload;
      })
      .addCase(getAllAppraisal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
      })

      .addCase(getAllUserAssignedAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.userAssignedAppraisal = [];
      })
      .addCase(getAllUserAssignedAppraisal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.error = null;
        state.userAssignedAppraisal = action.payload;
      })
      .addCase(getAllUserAssignedAppraisal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
        state.userAssignedAppraisal = [];
      })

      .addCase(assignAppraisalTemplate.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.message = "";
      })
      .addCase(assignAppraisalTemplate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.error = null;
        state.message = action.payload?.message || action.payload;
      })
      .addCase(assignAppraisalTemplate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
        state.message = "";
      })

      .addCase(deleteUserAssignedAppraisalById.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.message = "";
      })
      .addCase(deleteUserAssignedAppraisalById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.error = null;

        if (action.payload?.id) {
          state.userAssignedAppraisal = state.userAssignedAppraisal.filter(
            (appraisal) => appraisal.id !== action.payload.id
          );
        }
      })
      .addCase(deleteUserAssignedAppraisalById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
      })
      .addCase(getEmpAssignedAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.empAssignedAppraisalList = [];
      })
      .addCase(getEmpAssignedAppraisal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.empAssignedAppraisalList = action.payload;
      })
      .addCase(getEmpAssignedAppraisal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
        state.empAssignedAppraisalList = [];
      })

      .addCase(getManagerAssignedAppraisalById.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.managerAssignedAppraisalList = [];
      })
      .addCase(getManagerAssignedAppraisalById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.managerAssignedAppraisalList = action.payload;
      })
      .addCase(getManagerAssignedAppraisalById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
        state.managerAssignedAppraisalList = [];
      })

      .addCase(getEmployeeAppraisalList.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getEmployeeAppraisalList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.employeeAppraisals = action.payload;
      })
      .addCase(getEmployeeAppraisalList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.payload?.message;
        state.loading = false;
      })
      .addCase(createAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(createAppraisal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.error = "Appraisal Submitted Successfully";
        if (action.payload.editStatus === false) {
          state.appraisals = state.appraisals.concat(action.payload?.data);
          state.error = "Appraisal Submitted Successfully";
        } else if (action.payload.editStatus === true) {
          state.appraisals = state.appraisals?.map((appraisal) =>
            appraisal?.id === action.payload.data.id
              ? action.payload.data
              : appraisal
          );
          state.error = "Appraisal Modified Successfully";
        }
      })
      .addCase(createAppraisal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
      })
      .addCase(deleteAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAppraisal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.appraisals = state.appraisals?.filter(
          (appraisal) => appraisal?.id !== action.payload
        );
      })
      .addCase(deleteAppraisal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
        state.loading = false;
        showNotification("error", action.payload?.message);
      })

      .addCase(submitFinalAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(submitFinalAppraisal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.error = action.payload?.message;
      })
      .addCase(submitFinalAppraisal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || action.payload;
        state.loading = false;
      })

      .addCase(updateUserAdminAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.empAssignedAppraisalList = [];
      })
      .addCase(updateUserAdminAppraisal.fulfilled, (state, action) => {
        state.error =
          action.payload?.message || "Appraisal Update Successfully";
        state.status = "succeeded";
        state.loading = false;
        state.empAssignedAppraisalList = state.empAssignedAppraisalList?.map(
          (empApp) =>
            empApp?.id === action.payload?.id ? action.payload : empApp
        );
      })
      .addCase(updateUserAdminAppraisal.rejected, (state, action) => {
        state.status = "failed";
        // Extract error message from payload or error object
        const errorMessage = action.payload?.message || 
                            action.payload?.data?.message ||
                            action.payload ||
                            action.error?.message ||
                            "Failed to update appraisal";
        state.error = errorMessage;
        state.loading = false;
        state.empAssignedAppraisalList = [];
        showNotification("error", errorMessage);
      })
      .addCase(getStatusCountManagerAssignedAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getStatusCountManagerAssignedAppraisal.fulfilled,
        (state, action) => {
          state.status = "succeeded";
          state.loading = false;
          state.mgrStatusCounts = action.payload;
        }
      )
      .addCase(
        getStatusCountManagerAssignedAppraisal.rejected,
        (state, action) => {
          state.status = "failed";
          state.error = action.payload || action.error.message;
          state.loading = false;
          showNotification("error", action.payload?.message);
        }
      )
      .addCase(getAdminDashboardData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminDashboardData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.adminDataCounts = action.payload;
      })
      .addCase(getAdminDashboardData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
        state.loading = false;
        showNotification("error", action.payload?.message);
      })
      .addCase(getUserAssignedAppraisalDetails.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
        state.selectedAppraisal = null;
      })
      .addCase(getUserAssignedAppraisalDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.selectedAppraisal = action.payload;
      })
      .addCase(getUserAssignedAppraisalDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || action.payload;
        state.loading = false;
        showNotification("error", action.payload?.message);
        state.selectedAppraisal = null;
      })
      .addCase(getStatusCountUserAssignedAppraisal.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getStatusCountUserAssignedAppraisal.fulfilled,
        (state, action) => {
          state.status = "succeeded";
          state.loading = false;
          state.userDataCount = action.payload;
        }
      )
      .addCase(
        getStatusCountUserAssignedAppraisal.rejected,
        (state, action) => {
          state.status = "failed";
          const errorMessage = action.payload?.message || action.payload || action.error?.message || "Failed to load dashboard data";
          state.error = errorMessage;
          state.loading = false;
          // Don't show notification here - let the component handle it
        }
      );
  },
});

export const {
  updateAppraisal,
  updateMessage,
  updateSelectedAppraisal,
  resetSelectedAppraisalStates,
  clearAppraisalCache,
} = appraisalSlice.actions;

export const appraisalState = (state) => state.appraisalState;
export const getAllAppraisals = (state) => state?.appraisalState?.appraisals;
export const getEmployeeAppraisals = (state) =>
  state?.appraisalState?.employeeAppraisals;
export const selectAppraisalById = (state, appraisalId) =>
  state?.appraisalState?.appraisals?.find(
    (appraisal) => appraisal?.id === appraisalId
  );

export default appraisalSlice.reducer;
